<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="serviceAgreement">
      <service-agreement-form
        :isLoading="isLoading"
        :onSubmit="onSubmit"
        :serviceAgreement="serviceAgreement"
      ></service-agreement-form>
    </template>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ServiceAgreementForm from './ServiceAgreementForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { documentRegistry } = services;
const { serviceAgreementService } = documentRegistry;

export default {
  name: 'ServiceAgreementUpdate',
  components: {
    LandingCreate,
    ServiceAgreementForm,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Service Agreement Update',
      enableBackButton: true,
    },
    serviceAgreement: null,
  }),
  async created() {
    const { id } = this.$route.params;
    this.serviceAgreement = await serviceAgreementService.getOne({ id });
  },
  methods: {
    async onSubmit(dataChanges) {
      const data = Object.assign(this.serviceAgreement || {}, dataChanges);

      this.isLoading = true;
      try {
        const { _id, _metadata } = this.serviceAgreement;
        const serviceAgreementData = {
          _id,
          _metadata,
          name: data.name,
          description: data.description,
        };
        await serviceAgreementService.update({ serviceAgreement: serviceAgreementData });
        if (data.attachment) {
          const formData = new FormData();
          formData.append('attachment', data.attachment[0]);
          await serviceAgreementService.upload({ id: _id, formData });
        }
        this.isLoading = false;

        this.$snackbar.showOk({ text: 'Successfully updated service agreement!' });
        this.$router.push({ name: 'service-agreement.list' });
      } catch (e) {
        this.isLoading = false;
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
